export const myHomeConstants = {
  GET_MYHOME_ALL_REQUEST: 'MYHOME/GET_MYHOME_ALL_REQUEST',
  GET_MYHOME_ALL_SUCCESS: 'MYHOME/GET_MYHOME_ALL_SUCCESS',
  GET_MYHOME_ALL_FAILURE: 'MYHOME/GET_MYHOME_ALL_FAILURE',

  GET_MYHOME_MIXR_FUTURE_LIST_REQUEST: 'MYHOME/GET_MYHOME_MIXR_FUTURE_LIST_REQUEST',
  GET_MYHOME_MIXR_FUTURE_LIST_SUCCESS: 'MYHOME/GET_MYHOME_MIXR_FUTURE_LIST_SUCCESS',
  GET_MYHOME_MIXR_FUTURE_LIST_FAILURE: 'MYHOME/GET_MYHOME_MIXR_FUTURE_LIST_FAILURE',

  GET_MYHOME_MIXR_PAST_LIST_REQUEST: 'MYHOME/GET_MYHOME_MIXR_PAST_LIST_REQUEST',
  GET_MYHOME_MIXR_PAST_LIST_SUCCESS: 'MYHOME/GET_MYHOME_MIXR_PAST_LIST_SUCCESS',
  GET_MYHOME_MIXR_PAST_LIST_FAILURE: 'MYHOME/GET_MYHOME_MIXR_PAST_LIST_FAILURE',

  GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_REQUEST: 'MYHOME/GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_REQUEST',
  GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_SUCCESS: 'MYHOME/GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_SUCCESS',
  GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_FAILURE: 'MYHOME/GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_FAILURE',

  GET_MYHOME_SUGGESTED_MIXRS_REQUEST: 'MYHOME/GET_MYHOME_SUGGESTED_MIXRS_REQUEST',
  GET_MYHOME_SUGGESTED_MIXRS_SUCCESS: 'MYHOME/GET_MYHOME_SUGGESTED_MIXRS_SUCCESS',
  GET_MYHOME_SUGGESTED_MIXRS_FAILURE: 'MYHOME/GET_MYHOME_SUGGESTED_MIXRS_FAILURE',

  GET_MYHOME_GROUP_LIST_REQUEST: 'MYHOME/GET_MYHOME_GROUP_LIST_REQUEST',
  GET_MYHOME_GROUP_LIST_SUCCESS: 'MYHOME/GET_MYHOME_GROUP_LIST_SUCCESS',
  GET_MYHOME_GROUP_LIST_FAILURE: 'MYHOME/GET_MYHOME_GROUP_LIST_FAILURE',

  GET_MYHOME_SUGGESTED_GROUPS_REQUEST: 'MYHOME/GET_MYHOME_SUGGESTED_GROUPS_REQUEST',
  GET_MYHOME_SUGGESTED_GROUPS_SUCCESS: 'MYHOME/GET_MYHOME_SUGGESTED_GROUPS_SUCCESS',
  GET_MYHOME_SUGGESTED_GROUPS_FAILURE: 'MYHOME/GET_MYHOME_SUGGESTED_GROUPS_FAILURE',

  UPDATE_RSVP_DATA: 'MYHOME/UPDATE_RSVP_DATA',

  GET_ALL_INVITATIONS_REQUEST: 'MYHOME/GET_ALL_INVITATIONS_REQUEST',
  GET_ALL_INVITATIONS_SUCCESS: 'MYHOME/GET_ALL_INVITATIONS_SUCCESS',
  GET_ALL_INVITATIONS_FAILURE: 'MYHOME/GET_ALL_INVITATIONS_FAILURE',

  SET_GROUP_ROLE: 'MYHOME/SET_GROUP_ROLE'
}
